function initializeTripEntryMode() {
  const requestedMode = new URLSearchParams(window.location.search).get("tourType");
  const wrapper = $(".tour-wrapper").first();
  let selected = wrapper.find("input[name^=js-tour-type-radio]:checked").first();

  if (requestedMode === "offline" || window.location.hash === "#js-offline-tour-section") {
    const offline = wrapper.find("input[target^=js-offline-tour-section]").first();

    if (offline.length) selected = offline;
  } else if (requestedMode === "rail" || requestedMode === "air") {
    const online = wrapper.find(`.js-trip-transport-type[data-is-ground="${requestedMode === "rail"}"]`).first();

    if (online.length) selected = online;
  }

  if (!selected.length) selected = wrapper.find("input[name^=js-tour-type-radio]").first();

  selected.prop("checked", true).trigger("change");
}

$(function () {
  $(document).on("change", "input[type=radio][name^=js-tour-type-radio]", function (event) {
    const offline = (event.target.getAttribute("target") || "").indexOf("js-offline-tour-section") === 0;
    const ground = $(event.target).attr("data-is-ground") === "true";

    if (!offline) window.tripSearchIsGround = ground;

    $(".tour-wrapper").each(function () {
      const wrapper = $(this);

      wrapper.find(".js-tour-wrapper-item").removeClass("is-active");
      wrapper.find("input[name^=js-tour-type-radio]").each(function () {
        const target = $(this).attr("target") || "";
        const matches = offline ? target.indexOf("js-offline-tour-section") === 0 :
          target.indexOf("js-online-tour-section") === 0 && ($(this).attr("data-is-ground") === "true") === ground;

        $(this).prop("checked", matches);

        if (matches) wrapper.find(".js-tour-wrapper-item").filter(function () {
          return this.id === target;
        }).addClass("is-active");
      });
    });

    if (window.refreshTripSearchHistory) window.refreshTripSearchHistory();
  });

  initializeTripEntryMode();
  $(window).on("pageshow popstate", initializeTripEntryMode);
});